<div class="bgg-import-wrapper">
  <h5>{{ providerTitle() }}</h5>

  @if (showProviderSelector) {
    <div class="mb-3">
      <div class="btn-group" role="group" aria-label="Seleziona provider">
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-primary]="_provider() === 'bgg'"
          [class.btn-outline-primary]="_provider() !== 'bgg'"
          (click)="setProvider('bgg')"
        >
          BoardGameGeek (BGG)
        </button>
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-success]="_provider() === 'rpg'"
          [class.btn-outline-success]="_provider() !== 'rpg'"
          (click)="setProvider('rpg')"
        >
          RPGGeek
        </button>
      </div>
    </div>
  }

  <div class="d-flex gap-2 mb-3">
    <input
      class="form-control"
      type="text"
      [(ngModel)]="query"
      [placeholder]="placeholderText()"
      (keyup.enter)="search()"
    />
    <button class="btn btn-primary d-inline-flex align-items-center gap-1" (click)="search()" [disabled]="isSearching() || isImporting()">
      <i class="bi" [class.bi-hourglass-split]="isSearching()" [class.bi-search]="!isSearching()" aria-hidden="true"></i>
      <span>{{ isSearching() ? 'Ricerca...' : 'Cerca' }}</span>
    </button>
  </div>

  @if (searchResults().length > 0) {
    <div class="result-list">
      @for (result of searchResults(); track result.id) {
        <label class="result-item">
          <input type="checkbox" [checked]="isSelected(result)" (change)="toggleSelection(result)">
          <span>{{ result.name.value }} (ID: {{ result.id }})</span>
          @if (result.yearPublished?.value) {
            <small class="text-muted"> - {{ result.yearPublished?.value }}</small>
          }
          <span class="badge ms-2" [class.bg-primary]="resultSource(result) === 'BGG'" [class.bg-success]="resultSource(result) === 'RPGGeek'">
            {{ resultSource(result) }}
          </span>
        </label>
      }
    </div>

    <div class="d-flex gap-2 mt-3">
      <button class="btn btn-success d-inline-flex align-items-center gap-1" (click)="importSelected()"
              [disabled]="isImporting() || selectedIds().size === 0">
        <i class="bi" [class.bi-hourglass-split]="isImporting()" [class.bi-download]="!isImporting()" aria-hidden="true"></i>
        <span>{{ isImporting() ? 'Import in corso...' : 'Importa selezionati' }}</span>
      </button>
      <button class="btn btn-warning d-inline-flex align-items-center gap-1" (click)="closeSearch()">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
        <span>Chiudi</span>
      </button>
    </div>
  }

  @if (lastBulkResult(); as bulkResult) {
    <div class="mt-3 bulk-summary">
      <strong>Esito import:</strong>
      <div>Richiesti: {{ bulkResult.requested }}</div>
      <div>Importati: {{ bulkResult.imported }}</div>
      <div>Skippati (gia presenti): {{ bulkResult.skippedExisting }}</div>
      <div>Errori: {{ bulkResult.failed }}</div>
    </div>
  }
</div>
